import { v4 as uuid } from 'uuid';


export const addUniqueKeyForArrayItems = array => array
  .map(elem => ({ id: uuid(), value: elem }));
